import { z } from 'zod';
import { defineEndpoint } from '../define';
import { AdminAppleUdidSchema } from './shapes';

// Requires `releases:udids:manage`. Small catalogue (one row per teammate
// device) — plain list, no pagination, same as device-file-groups.
export const listAppleUdids = defineEndpoint({
  method: 'GET',
  path: '/v1/apple-udids',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: z.array(AdminAppleUdidSchema) }),
});
